module.exports = __webpack_public_path__ + "img/2125f82bd0070129e27efbfbf64d51c4.png";